/* global google */
import React from 'react'
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps'
import InfoBox from "react-google-maps/lib/components/addons/InfoBox"

// CSS
import '../../../css/maps.css'

/*
 * Map component will show a GoogleMap component via react-google-maps
 * 
 * Calling components must be wrapped in withScriptjs HOC.  This is so the maps library is loaded by the time this component is called.
 * Another reason is so this component won't have to deal with any geocoding, etc.  It just shows a map and markers.
 * The calling component can deal with loading the data. (See StoreMap.js)
 * 
 * Component must be given the following props in order to render a map of any kind:
 *  - containerElement
 *  - mapElement
 * 
 * Props for rendering a location:
 *  location: {
 *      lat: latitude number,
 *      lng: longitude number,
 *      obj: google maps.geometry.location object ** Possibly remove.  Was used when attempting to center InfoBox **
 *  }
 * 
 * Props for rendering markers:
 *  markers: [{
 *      lat: latitude number,
 *      lng: longitude number,
 *      txt: content for inside the InfoBox
 *  }]
 * 
 * ** NOTE: At this time, InfoBox components do not center on top of markers.
 *          They render on the bottom left because they are drawn with lat/lng starting there.
 */

export default withGoogleMap(props => {
        if(!props.location) return null

        const zoom = props.zoom ? props.zoom : 14

        return (
            <GoogleMap
                defaultZoom={zoom}
                defaultCenter={{ lat: props.location.lat, lng: props.location.lng }}
            >
                {props.markers && props.markers.map((marker, i) => <Marker key={i} position={{ lat: marker.lat, lng: marker.lng }} />)}
                {props.markers && props.markers.map((marker, i) =>
                    <InfoBox key={i}
                        defaultPosition={new google.maps.LatLng(marker.lat, marker.lng)}
                        options={{
                            pane: "overlayLayer",
                            pixelOffset: new google.maps.Size(-140, -60),
                            alignBottom: true,
                            boxStyle: {
                               boxShadow: `3px 3px 10px rgba(0,0,0,0.6)`
                            },
                            closeBoxURL : ""
                        }}
                    >
                        <div className="google_map_infobox">
                            {marker.txt}
                        </div>
                    </InfoBox>
                )}
            </GoogleMap>
        )
    }
)


// WEBPACK FOOTER //
// ./src/components/utils/maps/Map.js